module.exports = __webpack_public_path__ + "img/xeno-3.b879b006.jpg";